import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import QuizPage from "@/pages/QuizPage";
import FormPage from "@/pages/FormPage";
import ResultsPage from "@/pages/ResultsPage";
import { QuizProvider } from "@/context/QuizContext";

function App() {
  return (
    <div className="App">
      <QuizProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/quiz" element={<QuizPage />} />
            <Route path="/form" element={<FormPage />} />
            <Route path="/resultado/:resultId" element={<ResultsPage />} />
          </Routes>
        </BrowserRouter>
      </QuizProvider>
    </div>
  );
}

export default App;